<template>
  <div class="box">
    <Header title="聚焦实验室" backPage="mobile"></Header>
    <div class="addmode-btn-box" v-if="addMode">
      <div class="addmode-btn" @click="addCancel">取消</div>
      <div class="addmode-btn" @click="addComplete">完成</div>
    </div>
    <div class="show-box">
      <div class="title-card"></div>
      <div id="myFavouriteBox" class="icon-box">
        <div class="favourite-title">常用工具</div>
        <van-grid :border="false" square :gutter="15" :column-num="4">
          <van-grid-item v-for="(myItem, index) in myFavouriteList" :key="index">
            <van-image
              class="iconImge"
              width="52"
              height="52"
              fit="contain"
              :src="myItem.iconPic"
              @click="clickToPage1(myItem.iconRoute, myItem.iconId)"
            />
            <div class="iconName">{{ myItem.iconName }}</div>
            <van-icon
              v-if="addMode"
              class="addmode-icon icon-del"
              name="clear"
              @click="iconDel(myItem.iconId, index)"
            />
          </van-grid-item>
          <van-grid-item class="add-icon" v-if="!addMode">
            <div @click="addMyFavourite">+</div>
          </van-grid-item>
        </van-grid>
      </div>
      <div class="icon-box" v-for="(item) in list" :key="item.categoryName">
        <div class="title">{{item.categoryName}}</div>
        <van-grid :border="false" square :gutter="15" :column-num="4">
          <van-grid-item v-for="iconItem in item.userIconList" :key="iconItem.iconId">
            <van-image
              class="iconImge"
              width="52"
              height="52"
              fit="contain"
              :src="iconItem.iconPic"
              @click="clickToPage1(iconItem.iconRoute, iconItem.iconId)"
            />
            <div class="iconName">{{ iconItem.iconName }}</div>
            <van-icon
              v-if="addMode && !iconItem.addedFlag"
              class="addmode-icon icon-add"
              name="add"
              @click="iconAdd(iconItem)"
            />
            <van-icon
              v-if="addMode && iconItem.addedFlag"
              class="addmode-icon icon-added"
              name="checked"
            />
          </van-grid-item>
        </van-grid>
      </div>
    </div>
    <!-- <div v-if="!userNameCheckOk">aaa</div> -->
    <van-icon class="exchange-icon" name="exchange" @click="changeCss" />
  </div>
</template>

<script>
import Header from "@/components/Header";
import $ from "jquery";
import { checkParam, getIconList, saveFavorite, setClickRecord } from "@/api/motionFocus";
import { STATUS_CODE_OK } from "@/config";
import { mapActions } from "vuex";
import store from "@/store";
export default {
  name: "motionFocus",
  data() {
    return {
      userCode: "",
      // userNameCheckOk: true,
      colorFlag: "1",  //1：白天模式
      addMode: false,
      myFavouriteListBack: [],
      listBack: [],
      myFavouriteList: [],
      list: []
    };
  },
  mounted() {
    $(".show-box").css("padding", "0px 0px 30px 0px");
    this.userCheck();
    localStorage.removeItem('iconId');
    localStorage.removeItem('dealerId');
    localStorage.removeItem('dealerName');
    localStorage.removeItem('memberId');
  },
  methods: {
    async userCheck() {
      let { data } = await checkParam({
        appId: store.getters.userName
      });
      if (data.resultStatusCode === STATUS_CODE_OK) {
        this.userCode = data.userCode;
        this.setUserCode(data.userCode);
        // this.userNameCheckOk = true;
        this.getInitData();
      } else {
        // this.userNameCheckOk = false;
      }
    },
    async getInitData() {
      let { data } = await getIconList({
        userCode: this.userCode        
      });
      if (data.resultStatusCode === STATUS_CODE_OK) {
        if (data.userCateIcons && data.userCateIcons.length > 0) {
          this.list = data.userCateIcons;
          this.myFavouriteList = data.userFavoriteIcons;
          for (var i=0; i<this.list.length; i++) {
            for (var j=0; j<this.list[i].userIconList.length; j++) {
              var iconId = this.list[i].userIconList[j].iconId;
              this.list[i].userIconList[j]["addedFlag"] = false;
              for (var k=0; k<this.myFavouriteList.length; k++) {
                if ( this.myFavouriteList[k].iconId === iconId ) {
                  this.list[i].userIconList[j].addedFlag = true;
                }
              }
            }
          }
          this.listBack = this.copy(this.list);
          this.myFavouriteListBack = this.copy(this.myFavouriteList);
        } else {
          // this.userNameCheckOk = false;
        }
      }
    },
    addMyFavourite() {
      this.addMode = !this.addMode;
      $(".show-box").css("top", "90px");
    },
    changeCss() {
      if (this.colorFlag == "1") {
        this.colorFlag = "0";
        $("#app").attr("class", "black");
      } else {
        this.colorFlag = "1";
        $("#app").attr("class", "white");
      }
    },
    iconAdd(item) {
      item.addedFlag = true;
      var willAddItem = {
        categoryName: "",
        iconId: item.iconId,
        iconName: item.iconName,
        iconRoute: item.iconRoute,
        iconPic: item.iconPic
      };
      this.myFavouriteList.push(willAddItem);
    },
    iconDel(iconId, index) {
      for (var i = 0; i < this.list.length; i++) {
        for (var j = 0; j < this.list[i].userIconList.length; j++) {
          if (iconId == this.list[i].userIconList[j].iconId) {
            this.list[i].userIconList[j].addedFlag = false;
          }
        }
      }
      this.myFavouriteList.splice(index, 1);
    },
    async addComplete() {
      var myFavouriteIconList = [];
      for (var i=0; i<this.myFavouriteList.length; i++) {
        myFavouriteIconList.push(this.myFavouriteList[i].iconId)
      }
      let {data} = await saveFavorite ({
        userCode: store.getters.userCode,
        favoriteIconList: myFavouriteIconList
      })
      if (data.resultStatusCode === STATUS_CODE_OK) {
        this.addMode = !this.addMode;
        $(".show-box").css("top", "50px");
        this.listBack = this.copy(this.list);
        this.myFavouriteListBack = this.copy(this.myFavouriteList);
      }
    },
    addCancel() {
      this.myFavouriteList = this.copy(this.myFavouriteListBack);
      this.list = this.copy(this.listBack);
      this.addMode = !this.addMode;
      $(".show-box").css("top", "50px");
    },
    copy(myObj) {
      if (typeof myObj != "object" || myObj == null) return myObj;
      var newObj = new Object();
      if (myObj instanceof Array) {
        newObj = [];
      }
      for (var i in myObj) {
        newObj[i] = this.copy(myObj[i]);
      }
      return newObj;
    },
    async clickToPage1(iconRoute, iconId) {
      localStorage.setItem('iconId', iconId);
      await setClickRecord({
        userCode: this.userCode,
        iconId: iconId
      })

      if (!this.addMode && iconRoute && iconRoute !== "") {
        if(iconRoute.indexOf("http") == 0) {
          window.location.href = iconRoute;
        } else {
          this.$router.push({
            name: iconRoute
          });
        }
      }
    },
    ...mapActions(["setUserCode"])
  },
  components: {
    Header
  }
};
</script>
<style lang="scss" scoped>
.box {
  height: 100%;
  .addmode-btn-box {
    display: flex;
    font-size: 14px;
    justify-content: space-between;
    color: white;
    // background: linear-gradient(to right, #da291c 60%, #f2404d);
    background: #da291c;
    height: 40px;
    .addmode-btn {
      padding: 10px 20px;
    }
  }
  .icon-box {
    margin-bottom: 20px;
    min-height: 130px;
    .favourite-title {
      padding: 10px 15px 25px 20px;
      font-size: 16px;
      text-align: left;
      color: white;
    }
    .title {
      padding: 10px 15px 20px 20px;
      font-size: 16px;
      text-align: left;
    }
    .iconImge {
      flex-shrink: 0;
      padding-top: 10px;
      box-sizing: content-box;
    }
    .iconName {
      padding-top: 5px;
      padding-bottom: 10px;
      font-size: 12px;
      text-align: center;
      word-break: break-all;
    }
    .add-icon {
      height: auto;
      font-size: 65px;
      /deep/.van-grid-item__content {
        background: unset;
        border: 2px dashed white;
        color: #999;
      }
    }
    /deep/.van-grid-item__content--center {
      border-radius: 10px;
    }
  }
}
.exchange-icon {
  position: absolute;
  bottom: 20px;
  right: 20px;
  border-radius: 50px;
  width: 25px;
  height: 25px;
  line-height: 25px;
  border: 1px solid #cacaca;
  box-shadow: 0px 1px 0px #cacaca;
}
.addmode-icon {
  position: absolute;
  top: 2px;
  right: 2px;
  font-size: 16px;
}
.icon-add {
  color: rgb(19, 171, 218);
}
.icon-added {
  color: gray;
}
.icon-del {
  color: red;
}
</style>